// Sentry init — must be imported BEFORE any other app code.
// Graceful noop if REACT_APP_SENTRY_DSN is empty (contest deployment default).
import * as Sentry from "@sentry/react";

const dsn = process.env.REACT_APP_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV,
    release: process.env.REACT_APP_RELEASE,
    sendDefaultPii: false,
    // Only capture uncaught exceptions — no 4xx/network noise
    ignoreErrors: [
      "Network Error",
      "Request failed with status code 401",
      "Request failed with status code 403",
      "Request failed with status code 404",
    ],
  });
}

export { Sentry };
